import { trackClickEvent } from "@foundation/nextjs-gtm";
import { getCachedProcessEnv } from "~utils/getCachedProcessEnv";

const MAX_NEWS_FEED = 20;
const MAX_AGE_PARAM = 432000000;
const RESOURCE_TYPES_PARAM = "Story";
const RESCORERS_PARAM = "recent";
const { PERSONALIZATION_URL = "https://personalization.bloomberg.com" } =
  getCachedProcessEnv();

export async function fetchWatchlistNewsData(currentTags: string) {
  const newsRoute = `${PERSONALIZATION_URL}/user/recommendations/rr?limit=${MAX_NEWS_FEED}&maxAge=${MAX_AGE_PARAM}&resourceTypes=${RESOURCE_TYPES_PARAM}&rescorers=${RESCORERS_PARAM}&currentTags=${currentTags}`;

  try {
    const response = await fetch(`${newsRoute}`, {
      credentials: "include",
    });

    if (!response.ok) return null;

    return response.json();
  } catch (err) {
    trackClickEvent(
      "watchlistError",
      "Get Watchlist News Failure",
      "error",
      "watchlist"
    );
    console.error(err, "Fetching watchlist news error!!");
  }

  return null;
}
